/**
 * Created by mark on 17/12/2017.
 */

import BaseStore from './base-store.js';
import Constants from '../constants.js';

var _registerToActions = function(action){

    switch(action.actionType)
    {
        case Constants.TEST_STUDENT_IMPORT:
            console.log('here');
            this.testResults =  action.response;
            this.emit(Constants.TEST_STUDENT_IMPORT);
            break;
        case Constants.INSERT_STUDENT_IMPORT:

            this.results =  action.response;


            this.emit(Constants.INSERT_STUDENT_IMPORT);
            break;
    }

};

class ImportStore extends BaseStore{

    constructor(){
        super();
        this.testResults  = {};
        this.subscribe(() => _registerToActions.bind(this));
    }


    getTestResults(){
        return this.testResults;
    }

    getImportResults(){
        return this.testResults;
    }

}

export default new ImportStore();